export const condutor = {
  condutorProprioAssociado: null,
  condutorHabilitado: null,
  existeParentescoAssociado: null,
  dadosPessoaisCondutor: {
    nome: null,
    dataNascimento: null,
    idade: null,
    email: null,
    telefone: null,
    celular: null,
    genero: null,
    cnh: null,
    dataVencimentoCnh: null,
    categoriaCnh: null,
    cpf: null,
    rg: null,
    estadoCivil: null,
  },
  enderecoCondutor: {
    cep: null,
    rua: null,
    numero: null,
    bairro: null,
    cidade: null,
    estado: null,
  },
  observacaoSobreCondutor: null,
};
